import "react-medium-image-zoom/dist/styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { CyHeader } from "./CyHeader";
import { MouseEventHandler } from "react";
import { Button } from "reactstrap";

interface Props {
  icon: IconDefinition;
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
}

export function HeaderButton({ icon, onClick }: Props) {
  return (
    <Button
      color="primary"
      className="flex-grow-1"
      data-cy={CyHeader.HeaderButton}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={icon} />
    </Button>
  );
}
